import { render } from "./ManageAvatarCustomAvatarEditor.vue?vue&type=template&id=48509a1c"
import script from "./ManageAvatarCustomAvatarEditor.vue?vue&type=script&lang=js"
export * from "./ManageAvatarCustomAvatarEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__